module.exports = __webpack_public_path__ + "img/PayPal.85a7ecac.svg";